<template>
    <div>
        <div class="white-box md:mb-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isGettingData>0" />
                <div v-else>
                    <h4 class="text-error mb-2.5 font-normal">
                        您目前保單的通知方式為{{ userInfo.noteTypeText }} {{ getEmail() }}
                    </h4>
                    <div class="border-t border-gray-100 text-base mb-7 py-4 md:py-5">
                        <h4 class="text-secondary mb-2.5 font-bold">
                            請選擇欲變更之通知方式
                        </h4>
                        <Radio
                            v-for="(item,index) in notifyMethodList"
                            :key="index"
                            v-model:checkedValue="selected"
                            :value="item.value"
                            :text="item.notifyText"
                            :disabled="userInfo.noteType===item.value"
                            class="mb-2.5 items-baseline"
                        />
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="selected===''||selected===userInfo.noteType||isGettingData>0"
                    @click="saveAndgoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
        <PopupBase
            v-model:visiblePopup="visiblePopup"
            :params="{
                title: '提醒您',
                confirmButton: '確認',
                cancelButton: '我要變更',
                isDisabledButton: needEmailVerify && !isValid
            }"
            closeicon
            @cancel="cancelPopup"
            @confirm="confirmPopup"
            @handleClose="visiblePopup = false"
        >
            <template #content>
                <div class="mb-2">
                    <p class="w-full break-all pb-2">
                        保單帳戶價值將發送至以下E-mail：
                    </p>
                    <p class="w-full break-all text-green-600 pb-2">
                        {{ userInfo.email }}
                    </p>
                    <ValidEmailButton
                        v-model:propsValidEmail="propsValidEmail"
                        v-model:isValid="isValid"
                        :needEmailVerify="needEmailVerify"
                        :email="userInfo.email"
                    />
                </div>
                <p class="error-msg">
                    {{ errorMessage }}
                </p>
            </template>
        </PopupBase>
        <ValidEmail
            v-model:isValid="isValid"
            v-model:needEmailVerify="needEmailVerify"
            v-model:propsValidEmail="propsValidEmail"
            :inPopupBase="true"
            :email="userInfo.email"
        />
    </div>
</template>

<script>
import { ref, computed, reactive, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { getInfoAD, submitAD } from '@/apis/AD';
import Bottombar from '@/components/layout/Bottombar.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Loading from '@/components/Loading.vue';
import Radio from '@/components/radios/Radio.vue';
import PopupBase from '@/components/dialogs/Popup.vue';
import Skeletons from './Skeletons.vue';
import ValidEmail from '@/components/dialogs/ValidEmail.vue';
import ValidEmailButton from '@/components/buttons/ValidEmailButton.vue';
import { addAndInsertService } from '@/utils/changeItems/insertService';

export default {
    components: {
        Bottombar,
        Loading,
        Radio,
        ButtonNextService,
        Skeletons,
        PopupBase,
        ValidEmail,
        ValidEmailButton,
    },
    setup() {
        const route = useRoute();
        const { code } = route.meta;
        const store = useStore();
        const selected = ref('');
        const notifyMethodList = ref([]);
        const userInfo = ref({});
        const state = reactive({
            isLoading: false,
            isGettingData: 0,
            visiblePopup: false,
            isSubmitOk: false,
            isValid: false,
            needEmailVerify: true,
            propsValidEmail: false,
            errorMessage: '',
        });
        const result = computed(() => store.state.services.changeItemsResult[code]);

        // 取得api資料
        const getData = () => {
            state.isGettingData = 1;
            getInfoAD().then(res => {
                userInfo.value = res.data;
                if (!result.value) {
                    selected.value = res.data.noteType;
                }
            }).finally(() => {
                state.isGettingData -= 1;
            });
        };

        getData();

        if (!result.value) {
            notifyMethodList.value = [{ value: '1', notifyText: '書面通知' }, { value: '2', notifyText: 'E-mail通知' }];
        } else {
            const { storeList, selectVal } = result.value;
            selected.value = selectVal;
            notifyMethodList.value = storeList;
        }

        const saveAndgoNext = () => {
            if (isEmailNotify(selected.value)) {
                state.visiblePopup = true;
            } else {
                submit(true);
            }
        };

        const submit = (isConfirm) => {
            state.isLoading = true;
            const returnData = {
                noteType: selected.value,
            };
            submitAD(returnData).then(res => {
                const value = {
                    storeList: notifyMethodList.value,
                    storeUserInfo: userInfo.value,
                    selectVal: selected.value,
                };
                store.dispatch('services/setChangeItemsResult', { code, value });
                if (!isEmailNotify(selected.value) || isConfirm) {
                    state.visiblePopup = false;
                    state.isSubmitOk = true;
                }
            }).finally(() => {
                state.isLoading = false;
            });
        };

        const getEmail = () => {
            const email = userInfo.value.email;
            return isEmailNotify(userInfo.value.notify) && email ? `(${userInfo.value.email})` : '';
        };

        const isEmailNotify = (value) => {
            return value === '2';
        };

        /** 我要變更燈箱 */
        const cancelPopup = async () => {
            submit(false);
            state.visiblePopup = false;
            state.isLoading = true;
            await addAndInsertService(['BC', code], code);
            state.isLoading = false;
        };

        /** 確認燈箱 */
        const confirmPopup = async () => {
            if (state.needEmailVerify && !state.isValid) {
                state.errorMessage = '請先進行驗證Email';
                return;
            }
            submit(true);
        };

        return {
            selected,
            notifyMethodList,
            userInfo,
            ...toRefs(state),
            isEmailNotify,
            getEmail,
            cancelPopup,
            confirmPopup,
            saveAndgoNext,
        };
    },
};
</script>
